import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import { config } from "./firebase-config";
var FirebaseAuth = firebase.initializeApp(config.firebaseConfig);
var Firestore = firebase.firestore();
var CloudFunctions = firebase.functions();
export { FirebaseAuth, Firestore, CloudFunctions };
